const getNavigationTargetFromResponse = (
  _response: unknown,
): { resourceType: string; resourceId: string } | null => {
  return null;
};

export { getNavigationTargetFromResponse };
